import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 sm:px-6 bg-brand-taupe text-center text-brand-cream/60 text-[10px] sm:text-xs" data-id="element-72">
      <p className="leading-tight max-w-2xl mx-auto font-medium mb-3" data-id="element-73">
        © {new Date().getFullYear()} Dance Ready™ — All Rights Reserved. The
        content of this page is for informational and educational purposes only.
        It does not replace certified professional dance training or formal
        dance education qualifications. Always ensure safe teaching practices in
        your studio environment.
      </p>
      <div className="flex justify-center gap-2 sm:gap-3 font-bold tracking-wide uppercase" data-id="element-74">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-75">
          Terms & Conditions
        </a>
        <span data-id="element-76">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-77">
          Privacy Policy
        </a>
        <span data-id="element-78">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79">
          Contact
        </a>
      </div>
    </footer>;
}